import * as React from 'react';
import { IUser } from '../../api/models/IUser';

interface IAuth  {
  user: IUser | null;
  setUser: (user: IUser | null) => void;
  /**
   * Has the Keycloak session been established and the /me lookup completed?
   * False during the brief moment between Keycloak auth and the backend
   * round-trip that resolves the user record.
   */
  isAuthenticated: boolean;
  /**
   * Sign out: ends Keycloak's SSO session and redirects to the app origin.
   */
  signout: () => void;
  /**
   * Open Keycloak's account console (password, email, 2FA, etc.).
   */
  accountManagement: () => void;
}


const AuthContext = React.createContext<IAuth | null>(null);

export { AuthContext, IAuth }
